import { Answers } from "../types/quiz";

const GOALS: Record<string, string> = {
  A: "despertarte con menos hinchazón",
  B: "dormir mejor",
  C: "dejar de improvisar la cena",
  D: "comer liviano sin pasar hambre",
  E: "tener un plan claro de 7 días",
};

export function getPersonalization(answers: Answers) {
  const age = Number(answers.q1) || 0;
  const isOver35 = age >= 35;
  const goal = GOALS[answers.q18] ?? "dejar de improvisar la cena";
  const shortOnTime = ["A", "B", "E"].includes(answers.q15);
  const triedEverything = answers.q16 === "E";

  const notes: string[] = [];
  if (isOver35) {
    notes.push(`A los ${age} años, tu cuerpo no procesa la cena igual que a los 25. No es falta de voluntad: es biología que cambió.`);
  } else if (age > 0) {
    notes.push(`A los ${age} años es el mejor momento para aprender a cenar a favor de tu digestión, antes de que la hinchazón se vuelva rutina.`);
  }
  if (triedEverything) {
    notes.push("Si ya probaste de todo y seguís igual, probablemente no te faltó esfuerzo: te faltó mirar el momento del día en que tu cuerpo más trabaja de más.");
  }
  if (shortOnTime) {
    notes.push(
      answers.q15 === "E"
        ? "Como tu freno principal es la falta de ideas, necesitás un menú ya resuelto, no más información."
        : "Como tenés poco tiempo, necesitás cenas que estén listas en 15 minutos, sin pasos complicados."
    );
  }

  return { age, isOver35, goal, notes };
}
